enum LocalStorageKeyEnum {
  EmployeesTokens = 'employeesTokens',
  UserTokens = 'userTokens',
  SymmetricKey = 'symmetricKey',
  AsymmetricKeys = 'asymmetricKeys',
  ActiveOrganizationId = 'activeOrganizationId',
  Guid = 'guid',
  LastActivityTS = 'lastActivityTS',
  ShouldShowUnprocessedEmployeesWarning = 'shouldShowUnprocessedEmployeesWarning',
  ShouldShowUnprocessedEventsWarning = 'shouldShowUnprocessedEventsWarning'
}

export default LocalStorageKeyEnum;
